import React, { useEffect, useState } from 'react';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import InvoiceListPageActions from './Invoices/components/InvoiceListPageActions';
import CreditNoteListPageActions from './creditNotes/components/CreditNoteListPageActions';
import InvoiceListPage from './Invoices/pages/InvoiceListPage';
import CreditNoteListPage from './creditNotes/pages/CreditNoteListPage';
import DebitNoteListPage from './debitNotes/pages/DebitNoteListPage';
import RefundListPage from './refunds/pages/RefundListPage';
import { useSelector } from 'react-redux';
import TopBar from '../components/TopBar';
import DebitNoteListPageActions from './debitNotes/components/DebitNoteListPageActions';
import RefundListPageActions from './refunds/components/RefundListPageActions';
import BulkUploadListPageActions from './bulkUpload/components/BulkUploadListPageActions';

const tabs = [
  { key: 'invoices', label: 'Invoices' },
  { key: 'credit-notes', label: 'Credit Notes' },
  { key: 'debit-notes', label: 'Debit Notes' },
  { key: 'refunds', label: 'Refunds' },
];

const getTopBarTitle = (tab) => {
  switch (tab) {
    case 'invoices':
      return 'Invoice List';
    case 'credit-notes':
      return 'Credit Note List';
    case 'debit-notes':
      return 'Debit Note List';
    case 'refunds':
      return 'Refund List';
    default:
      return 'Documents';
  }
};

const getTopBarActions = (tab, user) => {
  if (user?.permissions?.documents !== 2) return null;

  switch (tab) {
    case 'invoices':
      return (
        <Stack direction="row" spacing={1}>
          <BulkUploadListPageActions />
          <InvoiceListPageActions />
        </Stack>
      );
    case 'credit-notes':
      return (
        <Stack direction="row" spacing={1}>
          <BulkUploadListPageActions />
          <CreditNoteListPageActions
            actions={[
              {
                label: '+ Create CN',
                action: 'create',
                target: '/documents/credit-notes/create',
              },
            ]}
          />
        </Stack>
      );
    case 'debit-notes':
      return (
        <Stack direction="row" spacing={1}>
          <BulkUploadListPageActions />
          <DebitNoteListPageActions
            actions={[
              {
                label: '+ Create DN',
                action: 'create',
                target: '/documents/debit-notes/create',
              },
            ]}
          />
        </Stack>
      );
    case 'refunds':
      return (
        <Stack direction="row" spacing={1}>
          <BulkUploadListPageActions />
          <RefundListPageActions
            actions={[
              {
                label: '+ Raise Refund',
                action: 'create',
                target: '/refunds/create',
              },
            ]}
          />
        </Stack>
      );
    default:
      return null;
  }
};

const getListPage = (tab) => {
  switch (tab) {
    case 'invoices':
      return <InvoiceListPage />;
    case 'credit-notes':
      return <CreditNoteListPage />;
    case 'debit-notes':
      return <DebitNoteListPage />;
    case 'refunds':
      return <RefundListPage />;
    default:
      return null;
  }
};

const DocumentListPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.org.org.user);
  const queryParams = new URLSearchParams(location.search);
  const initialTab = queryParams.get('tab') || 'invoices';
  const [selectedTab, setSelectedTab] = useState(initialTab);
  const totalBusinessProfiles = useSelector((state) => state.org.org.totalBusinessProfiles);

  useEffect(() => {
    setSelectedTab(initialTab);
  }, [initialTab]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    navigate(`/documents?tab=${newValue}`);
  };

  return (
    <Stack direction="column" spacing={3}>
      <TopBar title={getTopBarTitle(selectedTab)} />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Tabs value={selectedTab} onChange={handleTabChange}>
          {tabs.map((tab) => (
            <Tab key={tab.key} label={tab.label} value={tab.key} />
          ))}
        </Tabs>
        {getTopBarActions(selectedTab, user)}
      </Box>
      <Box>{getListPage(selectedTab)}</Box>
    </Stack>
  );
};

export default DocumentListPage;
